var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYoutube1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4199 8.23785C21.4199 8.23785 21.2399 6.91785 20.6399 6.31785C19.9199 5.53785 19.0799 5.53785 18.7199 5.47785C16.0199 5.29785 11.9999 5.29785 11.9999 5.29785C11.9999 5.29785 7.9799 5.29785 5.2799 5.47785C4.9199 5.53785 4.0799 5.53785 3.3599 6.31785C2.7599 6.91785 2.5799 8.23785 2.5799 8.23785C2.5799 8.23785 2.3999 9.79785 2.3999 11.3579L2.3999 12.7979C2.3999 14.3579 2.5799 15.9179 2.5799 15.9179C2.5799 15.9179 2.7599 17.2379 3.3599 17.8379C4.0799 18.6179 5.0399 18.5579 5.4599 18.6779C7.0199 18.7979 11.9999 18.8579 11.9999 18.8579C11.9999 18.8579 16.0199 18.8579 18.7199 18.6779C19.0799 18.6179 19.9199 18.6179 20.6399 17.8379C21.2399 17.2379 21.4199 15.9179 21.4199 15.9179C21.4199 15.9179 21.5999 14.3579 21.5999 12.7979L21.5999 11.3579C21.5999 9.79785 21.4199 8.23785 21.4199 8.23785ZM10.0199 14.5979L10.0199 9.19785L15.1799 11.8979L10.0199 14.5979Z",
    fill: "#E82E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube1);
export default __webpack_public_path__ + "static/media/logo-youtube-1.9f1d6cdf7fa5d15f180b7c972df8e122.svg";
export { ForwardRef as ReactComponent };